"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CreditCardType = exports.SalesforceApiBillingType = exports.PaymentTerms = exports.BillingAccountRequestUserAction = exports.BillingAccountRequestUserType = void 0;
var BillingAccountRequestUserType;
(function (BillingAccountRequestUserType) {
    BillingAccountRequestUserType["BillingContact"] = "BillingContact";
    BillingAccountRequestUserType["SecurityContact"] = "SecurityContact";
    BillingAccountRequestUserType["TechnicalContact"] = "TechnicalContact";
})(BillingAccountRequestUserType || (exports.BillingAccountRequestUserType = BillingAccountRequestUserType = {}));
var BillingAccountRequestUserAction;
(function (BillingAccountRequestUserAction) {
    BillingAccountRequestUserAction["Add"] = "Add";
    BillingAccountRequestUserAction["Remove"] = "Remove";
    BillingAccountRequestUserAction["Update"] = "Update";
})(BillingAccountRequestUserAction || (exports.BillingAccountRequestUserAction = BillingAccountRequestUserAction = {}));
var PaymentTerms;
(function (PaymentTerms) {
    PaymentTerms["CreditCard"] = "Credit Card";
    PaymentTerms["InvoiceNet30"] = "Invoice - Net 30";
    PaymentTerms["InvoiceNet45"] = "Invoice - Net 45";
    PaymentTerms["InvoiceNet60"] = "Invoice - Net 60";
    PaymentTerms["InvoiceNet90"] = "Invoice - Net 90";
})(PaymentTerms || (exports.PaymentTerms = PaymentTerms = {}));
var SalesforceApiBillingType;
(function (SalesforceApiBillingType) {
    SalesforceApiBillingType["Upfront"] = "Upfront";
    SalesforceApiBillingType["Recurring"] = "Recurring";
})(SalesforceApiBillingType || (exports.SalesforceApiBillingType = SalesforceApiBillingType = {}));
var CreditCardType;
(function (CreditCardType) {
    CreditCardType["Visa"] = "VISA";
    CreditCardType["Mastercard"] = "Mastercard";
    CreditCardType["Amex"] = "AmericanExpress";
})(CreditCardType || (exports.CreditCardType = CreditCardType = {}));
//# sourceMappingURL=billingAccount.js.map